import Cookies from "js-cookie";

/**
 * Site Announcements
 */
const SiteAnnouncement = () => {
  const announcement = document.querySelector(".announcement");

  if (announcement) {
    const toggle = document.querySelector(".announcement-toggle");
    const timestamp = announcement.getAttribute("data-timestamp");
    const endTime = announcement.getAttribute("data-expires");

    // Set default expiry
    let expiry = 365;

    // If we have an expiry timestamp then set our cookie expiry to this
    if (endTime) {
      expiry = new Date(endTime);
    }

    toggle.addEventListener("click", () => {
      announcement.classList.add("announcement--disable");
      Cookies.set("ANNOUNCEMENT_CLOSED", timestamp, { expires: expiry });
    });

    // Hide the alert by default if we have our closed cookie
    if (
      Cookies.get("ANNOUNCEMENT_CLOSED") !== "undefined" &&
      Cookies.get("ANNOUNCEMENT_CLOSED") !== timestamp
    ) {
      announcement.classList.remove("announcement--disable");
    }
  }
};

export default SiteAnnouncement;
